var formatSpanishOrdinalNumber = function (n) {
    var suffixes = [
        'ma',
        'era',
        'da',
        'ra',
        'ta',
        'ta',
        'ta',
        'ma',
        'va',
        'na'
    ];
    var computation = n % 10;
    var suffix = n > 0 ? suffixes[computation] : '';
    return "".concat(n).concat(suffix);
};
var formatEnglishOrdinalNumber = function (n) {
    var suffixes = ['th', 'st', 'nd', 'rd'];
    var computation = (n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10;
    var suffix = n > 0 ? suffixes[computation] : '';
    return "".concat(n).concat(suffix);
};
export var formatOrdinalNumber = function (n) {
    var language = localStorage.getItem('language') || 'en';
    return language === 'es'
        ? formatSpanishOrdinalNumber(n)
        : formatEnglishOrdinalNumber(n);
};
//# sourceMappingURL=formatOrdinalNumber.js.map